/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a chemical formula to calculate its molar mass.`)
};

const es_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una fórmula química para calcular su masa molar.`)
};

const de_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine chemische Formel ein, um ihre molare Masse zu berechnen.`)
};

const nl_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een chemische formule in om de molaire massa te berekenen.`)
};

const fr_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une formule chimique pour calculer sa masse molaire.`)
};

const it_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una formula chimica per calcolarne la massa molare.`)
};

const pt_br2_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma fórmula química para calcular sua massa molar.`)
};

const pt_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma fórmula química para calcular a sua massa molar.`)
};

const ja_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学式を入力するとモル質量が計算されます。`)
};

const zh_mw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入化学式以计算其摩尔质量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_hint_empty", locale)
	if (locale === "en") return en_mw_hint_empty(inputs)
	if (locale === "es") return es_mw_hint_empty(inputs)
	if (locale === "de") return de_mw_hint_empty(inputs)
	if (locale === "nl") return nl_mw_hint_empty(inputs)
	if (locale === "fr") return fr_mw_hint_empty(inputs)
	if (locale === "it") return it_mw_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_mw_hint_empty(inputs)
	if (locale === "pt") return pt_mw_hint_empty(inputs)
	if (locale === "ja") return ja_mw_hint_empty(inputs)
	return zh_mw_hint_empty(inputs)
};